/**
 * Polyfills for older browsers
 * remove when no longer supported
 */

/* picture-tag polyfill for IE */
require('./Polyfills/picturefill')

/* Array.prototype.includes polyfill for IE */
require('./Polyfills/Array.prototype.includes')

/* Array.prototype.flat, Array.prototype.flatMap polyfills */
require('./Polyfills/Array.prototype.flat');

/* window.fetch polyfill for IE and Edge */
import 'whatwg-fetch'
